(function () {
  function init() {
    var section = document.querySelector('.albirouhi-product');
    if (!section) return;
    // Find by parent, not by class, so this works for every image source
    // (admin media via image_tag, baked asset, swatch). Historical note:
    // the admin-path img once lost its class because the Liquid wrote
    // `alt: x | default: y` inside the image_tag arguments (the pipe
    // starts a new filter and drops class/widths). Fixed in the section
    // in 2026-11; the parent selector stays as belt-and-braces.
    var mainImage = section.querySelector('.albirouhi-product-frame img');
    if (!mainImage) return;

    function setActive(thumb) {
      section.querySelectorAll('.albirouhi-product-thumb').forEach(function (t) {
        t.classList.remove('is-active');
      });
      if (thumb) thumb.classList.add('is-active');
    }

    // Event delegation so it survives any thumb DOM changes
    section.addEventListener('click', function (e) {
      var thumb = e.target.closest('.albirouhi-product-thumb');
      if (!thumb) return;
      var url = thumb.getAttribute('data-image');
      if (!url) return;
      // Clear srcset + sizes so the browser uses the new src, not the
      // responsive variants of the previous image
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = url;
      setActive(thumb);
    });

    // Mark first thumb active on load
    var first = section.querySelector('.albirouhi-product-thumb');
    if (first) first.classList.add('is-active');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
